import { css } from 'styled-components';

export const spacingBox = css`
  padding: 16px;
`;

// ptp config has 6 digits hex => need to concat an extra 2 digits for alpha % (FF or CC) so that opacity won't affect child components
// reference: https://css-tricks.com/8-digit-hex-codes/
export const blurBox = css`
  ${spacingBox}
  background-color: ${({ theme }) =>
    theme.configs.parcelDetailsBox.bgImage
      ? `${theme.configs.secondaryBox.bgColor}CC`
      : `${theme.configs.secondaryBox.bgColor}FF`};
  color: ${({ theme }) => theme.configs.secondaryBox.fontColor};
`;

export const timeDescription = css`
  margin-bottom: 8px;
  font-size: ${({ theme }) => theme.configs.fonts.fontSize.additionalDetails}px;
`;
